import type { LocalMarketApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';

import { SearchMarketCard } from '../LocalMarketSearch/SearchMarketCard';
import { SearchMarketCardSkeleton } from '../LocalMarketSearch/SearchMarketCardSkeleton';
import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';

const PREVIEW_SLIDER_COUNT = 5;

export function LocalMarketPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: LocalMarketApiDto[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="웰마켙"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: { q: keyword || undefined, category: 'welmarket' },
        })}
      />
      {isLoading ? (
        <HorizontalSlider className="mobile-tablet:pl-20">
          {Array.from({ length: PREVIEW_SLIDER_COUNT }, (_, index) => (
            <div
              key={index}
              className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"
            >
              <SearchMarketCardSkeleton />
            </div>
          ))}
        </HorizontalSlider>
      ) : (
        <HorizontalSlider className="mobile-tablet:pl-20">
          {items.map((item) => (
            <div
              key={item.localMarketProductId}
              className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"
            >
              <SearchMarketCard
                productId={item.localMarketProductId}
                imageUrl={item.productImageUrl}
                productName={item.productName}
                region={item.region}
                originalPrice={item.originalPrice}
                expectedFinalPrice={item.expectedFinalPrice}
                discountRate={item.discountRate}
                rating={item.rating}
                reviewCount={item.reviewCount}
              />
            </div>
          ))}
        </HorizontalSlider>
      )}
    </section>
  );
}
